import React, { useEffect, useState } from "react";
import Container from "components/container";
import ContentContainer from "components/content-container";
import { Link, useParams } from "react-router-dom";
import LoadingComponent from "components/loading-component";
import Text from "components/text";
import CompanyAdmin from "pages/company-admin";
import { ContractorSubmittalsService } from "apis/Services/ContractorSubmittalsService";
import styles from "./contractor-submittal.module.css";
import { CaretRightOutlined, FlagFilled } from "@ant-design/icons";
import {
  Badge,
  Button,
  Card,
  Collapse,
  Result,
  Tooltip,
  Tabs,
  Tag,
  Empty,
} from "antd";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import Submittal from "./submittal";

const { Panel } = Collapse;

const ContractorSubmittals = ({}) => {
  const { email, entryID, company_id, id, company_name, project_name } =
    useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [mainEntryData, setMainEntryData] = useState();
  const [otherSubmittals, setOtherSubmittals] = useState();
  const [workingDays, setWorkingDays] = useState();
  const [nonWorkingDays, setNonWorkingDays] = useState();
  const [itemsPendingApprovals, setItemsPendingApprovals] = useState();
  const [filteredData, setFilteredData] = useState([]);

  const [changedEntries, setChangedEntries] = useState({});

  const [companyName, setCompanyName] = useState("");
  const [projectName, setProjectName] = useState("");

  const [filter, setFilter] = useState("");

  const [expandedPanels, setExpandedPanels] = useState([]);
  const allExpanded = expandedPanels.length === otherSubmittals?.length;

  const ContractorSubmittals = async () => {
    let requestData = {
      company_id,
      id,
      entryID,
      email,
    };

    // console.log(requestData);

    try {
      const res =
        await ContractorSubmittalsService.procurementLogReadSpecificSubmittalContractor(
          requestData
        );

      console.log(res);

      setMainEntryData(res?.entryContent[0]);
      setOtherSubmittals(res?.content);
      setCompanyName(company_name);
      setProjectName(project_name);
      setWorkingDays(res.workingDays);
      setNonWorkingDays(res.nonWorkingDays);
      setItemsPendingApprovals(res.itemsPendingApprovals);

      console.log(res?.content);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const editSubmittal = async (entry) => {
    let requestData = {
      company_id,
      id,
      email,
      entries: [
        {
          entryID: entry.entryID,
          specSection: entry.specSection,
          specNumber: entry.specNumber,
          specTitle: entry.specTitle,
          specRevision: entry.specRevision,
          leadTime: entry.leadTime,
          subCommittedDeliveryDate: entry.subCommittedDeliveryDate,
        },
      ],
    };

    try {
      const res =
        await ContractorSubmittalsService.procurementLogContractorEditEntry(
          requestData
        );

      // Remove from changedEntries
      setChangedEntries((prev) => {
        const updated = { ...prev };
        delete updated[entry.entryID];
        return updated;
      });

      // Add to submitted items
      setItemsPendingApprovals((prev) => [
        ...new Set([...prev, entry.entryID]),
      ]);

      // Update approval fields locally
      setOtherSubmittals((prev) =>
        prev.map((item) =>
          item.entryID === entry.entryID
            ? {
                ...item,
                leadTimeApproval: entry.leadTime,
                subCommittedDeliveryDateApproval:
                  entry.subCommittedDeliveryDate,
              }
            : item
        )
      );

      if (mainEntryData?.entryID === entry.entryID) {
        setMainEntryData((prev) => ({
          ...prev,
          leadTimeApproval: entry.leadTime,
          subCommittedDeliveryDateApproval: entry.subCommittedDeliveryDate,
        }));
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitAll = async () => {
    const entriesToSubmit = Object.values(changedEntries).filter(
      (entry) => !itemsPendingApprovals.includes(entry.entryID)
    );

    if (entriesToSubmit.length === 0) return;

    const requestData = {
      company_id,
      id,
      email,
      entries: entriesToSubmit,
    };

    setIsLoading(true);
    try {
      const res =
        await ContractorSubmittalsService.procurementLogContractorEditEntry(
          requestData
        );
      console.log(res);

      // Clear submitted entries from changedEntries
      const submittedIDs = entriesToSubmit.map((e) => e.entryID);
      setChangedEntries((prev) => {
        const updated = { ...prev };
        submittedIDs.forEach((id) => delete updated[id]);
        return updated;
      });

      setItemsPendingApprovals((prev) => [
        ...new Set([...prev, ...submittedIDs]),
      ]);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    ContractorSubmittals();
  }, []);

  return (
    <Container>
      <div className=" d-flex justify-content-center align-items-center mt-4">
        <h3 className=" fw-bold">My Assigned Items</h3>
      </div>

      <ContentContainer className="px-3 py-1 my-4">
        {!isLoading ? (
          <div className="my-4">
            <div className=" d-flex justify-content-between mb-4">
              <Text className={`${styles.title}`}>{projectName}</Text>
              <Text className={`${styles.title}`}>{companyName}</Text>
            </div>

            <Tabs
              defaultActiveKey="1"
              type="card"
              items={[
                {
                  label: "Current",
                  key: "1",
                  children: !mainEntryData ? (
                    <div className="text-center py-3">
                      <Empty
                        description={
                          <span style={{ fontSize: "1rem" }}>
                            No Assigned Items
                          </span>
                        }
                      />
                    </div>
                  ) : (
                    <Collapse
                      className={`my-2 ${styles.panelStyling}`}
                      key={mainEntryData?.entryID}
                      ghost
                      expandIconPosition="start"
                      expandIcon={() => null}
                      activeKey={["1"]}
                    >
                      <Panel
                        header={
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <div className=" d-flex align-items-center gap-2">
                              <span>
                                {mainEntryData?.specTitle ||
                                  "Unnamed Submittal"}
                              </span>

                              {mainEntryData?.criticalPathFlag === "True" && (
                                <Tooltip title="Critical Path">
                                  <FlagFilled style={{ fontSize: "0.8rem" }} />
                                </Tooltip>
                              )}
                            </div>

                            <div>
                              {itemsPendingApprovals?.includes(
                                mainEntryData?.entryID
                              ) ? (
                                <span
                                  style={{
                                    color: "#0195D9",
                                    backgroundColor: "#e6f0ff",
                                    padding: "0.2rem 0.5rem",
                                    borderRadius: "5px",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  Submitted
                                </span>
                              ) : (
                                <span
                                  style={{
                                    color: "#E60200",
                                    backgroundColor: "#ffe6e6",
                                    padding: "0.2rem 0.5rem",
                                    borderRadius: "5px",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  Not Submitted
                                </span>
                              )}
                            </div>
                          </div>
                        }
                        key="1"
                      >
                        <Submittal
                          submittal={mainEntryData}
                          workingDays={workingDays}
                          nonWorkingDays={nonWorkingDays}
                          editSubmittal={editSubmittal}
                          itemsPendingApprovals={itemsPendingApprovals}
                          onChange={(changedItem) => {
                            setChangedEntries((prev) => ({
                              ...prev,
                              [changedItem.entryID]: changedItem,
                            }));
                          }}
                        />
                      </Panel>
                    </Collapse>
                  ),
                },
                {
                  label: "All Items",
                  key: "2",
                  children:
                    otherSubmittals && otherSubmittals.length > 0 ? (
                      <>
                        <div className="w-100 d-flex justify-content-between mb-3">
                          <div className="d-flex gap-2">
                            <Button
                              onClick={() =>
                                setExpandedPanels(
                                  allExpanded
                                    ? []
                                    : otherSubmittals.map((_, i) =>
                                        i.toString()
                                      )
                                )
                              }
                            >
                              {allExpanded ? "Collapse All" : "Expand All"}
                            </Button>
                          </div>
                          <Button
                            type="primary"
                            disabled={
                              Object.values(changedEntries).filter(
                                (e) =>
                                  !itemsPendingApprovals.includes(e.entryID)
                              ).length === 0
                            }
                            onClick={handleSubmitAll}
                          >
                            Submit All
                          </Button>
                        </div>
                        {otherSubmittals.map((item, index) => (
                          <Collapse
                            className={`my-2 ${styles.panelStyling}`}
                            key={index}
                            activeKey={
                              expandedPanels.includes(index.toString())
                                ? ["1"]
                                : []
                            }
                            onChange={() => {
                              setExpandedPanels((prev) =>
                                prev.includes(index.toString())
                                  ? prev.filter((k) => k !== index.toString())
                                  : [...prev, index.toString()]
                              );
                            }}
                            ghost
                            expandIconPosition="start"
                            expandIcon={({ isActive }) => (
                              <CaretRightOutlined rotate={isActive ? 90 : 0} />
                            )}
                          >
                            <Panel
                              header={
                                <div className="d-flex justify-content-between align-items-center w-100">
                                  <div className=" d-flex align-items-center gap-2">
                                    <span>
                                      {item?.specTitle || "Unnamed Submittal"}
                                    </span>

                                    {item.criticalPathFlag === "True" && (
                                      <Tooltip title="Critical Path">
                                        <FlagFilled
                                          style={{ fontSize: "0.8rem" }}
                                        />
                                      </Tooltip>
                                    )}
                                  </div>

                                  <div>
                                    {itemsPendingApprovals.includes(
                                      item.entryID
                                    ) ? (
                                      <span
                                        style={{
                                          color: "#0195D9",
                                          backgroundColor: "#e6f0ff",
                                          padding: "0.2rem 0.5rem",
                                          borderRadius: "5px",
                                          fontSize: "0.8rem",
                                        }}
                                      >
                                        Submitted
                                      </span>
                                    ) : (
                                      <span
                                        style={{
                                          color: "#E60200",
                                          backgroundColor: "#ffe6e6",
                                          padding: "0.2rem 0.5rem",
                                          borderRadius: "5px",
                                          fontSize: "0.8rem",
                                        }}
                                      >
                                        Not Submitted
                                      </span>
                                    )}
                                  </div>
                                </div>
                              }
                              key="1"
                            >
                              <Submittal
                                submittal={item}
                                workingDays={workingDays}
                                nonWorkingDays={nonWorkingDays}
                                editSubmittal={editSubmittal}
                                itemsPendingApprovals={itemsPendingApprovals}
                                onChange={(changedItem) => {
                                  setChangedEntries((prev) => ({
                                    ...prev,
                                    [changedItem.entryID]: changedItem,
                                  }));
                                }}
                              />
                            </Panel>
                          </Collapse>
                        ))}
                      </>
                    ) : (
                      <Empty
                        description={
                          <span style={{ fontSize: "1rem" }}>
                            No Assigned Items
                          </span>
                        }
                      />
                    ),
                },
              ]}
            />
          </div>
        ) : (
          <div className="my-4">
            <LoadingComponent />
          </div>
        )}
      </ContentContainer>
    </Container>
  );
};

export default ContractorSubmittals;
